import '@lcsc-ui/utils/compliant';
import { useLayoutEffect } from 'react';

import dataplus from '@lcsc/data-plus';
// eslint-disable-next-line import/order
import { pathDataPolyfill } from '@lcsc-ui/lib/path-data-polyfill';

import '@lcsc-ui/styles/ant-reset.less';
import '@lcsc-ui/styles/globals.css';

import { ConfigProvider, message } from 'antd';
import locale from 'antd/es/locale/zh_CN';

import { env } from '@/utils/baseUrl';

import 'moment/locale/zh-cn';

const MyNextApp = ({ Component, pageProps }) => {
  useLayoutEffect(() => {
    try {
      pathDataPolyfill();
      dataPlusInit();
    } catch (err) {
      console.error(err);
    }
    message.config({
      top: 400,
      duration: 3,
      maxCount: 5,
    });
  }, []);

  // 监控sdk开关
  function dataPlusInit() {
    // 初始化埋点
    if (typeof window !== 'undefined') {
      let dataplus_url = 'https://collector.szlcsc.com';
      if (['fat', 'dev', 'uat'].includes(env)) {
        dataplus_url = `https://${env}collector.szlcsc.com`;
      } else if (['local'].includes(env)) {
        dataplus_url = `https://devcollector.szlcsc.com`;
      }
      dataplus?.init({
        c_url: `${dataplus_url}/collect.js`,
        pf: 'pc',
      });
    }
  }

  return (
    <div id="lc-list" className={'bg-[#f5f5f7]'}>
      <ConfigProvider locale={locale} autoInsertSpaceInButton={false}>
        <Component {...pageProps} />
      </ConfigProvider>
    </div>
  );
};

export default MyNextApp;
